export class OtsStaffEuroUtils {

  public static format(cents: number): string {
    const [euros, rest] = (cents / 100).toFixed(2).split('.');
    return `€${euros},${rest}`;
  }
}
